//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios, {
  CancelToken
} from 'axios'

export default {
  data() {
    return {
      eff: [],

    }

  },
  mounted() {
    this.LoadData()

  },
  computed: {
    "columns": function columns() {
      if (this.eff.length == 0) {
        return [];
      }
      return Object.keys(this.eff[0])
    }
  },
  methods: {
    async LoadData() {

      let params = new FormData()

      params.append("ws", '202010')
      params.append("we", '202040')

      await axios({
        method: "post",
        url: 'http://127.0.0.1:9000/eff_doc_group',
        data: params
      }).then(res => {
        // console.log(res.data)
        this.eff = res.data
      })

    },
    CellClass(val) {
      if (val == null) {
        return "background-color:silver"
      } else if (val == 0) {
        return "background-color:#ffffff"
      } else if (val < 10) {
        return "background-color:#eaf4ea"
      } else if (val < 20) {
        return "background-color:#d5ead5"
      } else if (val < 30) {
        return "background-color:#c0e0c0"
      } else if (val < 40) {
        return "background-color:#abd5ab"
      } else if (val < 50) {
        return "background-color:#97cb97"
      } else if (val < 60) {
        return "background-color:#82c182"
      } else if (val < 70) {
        return "background-color:#6db66d"
      } else if (val < 80) {
        return "background-color:#58ac58"
      } else if (val < 90) {
        return "background-color:#43a243"
      } else if (val >= 90) {
        return "background-color:#2f982f"
      }

    }
  }
}
